module.exports = __webpack_public_path__ + "media/images/favicons/apple-touch-icon-114x114-4e7f4b7caa310b0fb335838cef8ece94.png";